import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  LangChooseFile, LangDownloadImportFormat, LangDownloadImportUpdateClientFormat,
  LangImportant, LangImportCancel, LangImportDone,
  LangImportErrorMsg1, LangImportErrorMsg2,
  LangImportHelp1, LangImportHelp2, LangImportHelp3,
  LangImportUpdateErrorReason, LangImportUpdateFailedCount, LangImportUpdateSuccessCount,
  LangMaxSize, LangProcess, LangRow, LangUpdateClient
} from '../../constant/languange'
import { axiosCompany, mapStateToProps, SpinnerButton } from '../../helpers/Common'
import { ModalApp } from '../../helpers/Input'
import ClientImportUpdateFormatComponent from './ClientImportUpdateFormatComponent'

function ClientImportUpdateComponent({ redux, handleClose, handleUpdate }) {
  const [errors, setError] = useState({ fields: {}, message: '' })
  const [control, setControl] = useState({ showLoad: false, showModal: '' })
  const [importResult, setImportResult] = useState(null)
  const [file, setFile] = useState('')

  const importExcelService = (e) => {
    e.preventDefault()
    const formData = new window.FormData()
    formData.append('file', file)

    setControl(curr => ({ ...curr, showLoad: true }))
    setError({ fields: {}, message: '' })
    setImportResult(null)

    axiosCompany().post('client-visit-clients/import-excel-update', formData)
      .then(res => {
        setImportResult(res.data)
        setControl(curr => ({ ...curr, showLoad: false }))
        handleUpdate()
      })
      .catch(e => {
        setError({
          fields: e.response.data.errors || { 0: [e.response.statusText] },
          message: e.response.data.message || ''
        })
        setControl(curr => ({ ...curr, showLoad: false }))
      })
  }

  const handleChangeFile = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0])
    }
  }

  return (
    <div>
      <div className={`alert ${redux.darkModeOn ? 'alert-dark' : 'alert-light'}`}>
        <b>{LangImportant.toUpperCase()}!</b>
        <ul style={{ listStyleType: 'circle', paddingLeft: '40px' }}>
          <li>{LangImportHelp1(LangUpdateClient)}. <a className='link' style={{ cursor: 'pointer' }} onClick={() => setControl(curr => ({ ...curr, showModal: 'format-import' }))}>{LangDownloadImportFormat}</a>.</li>
          <li>{LangImportHelp2}.</li>
          <li>{LangImportHelp3}.</li>
        </ul>
      </div>

      <form className='form' onSubmit={importExcelService} autoComplete='off'>
        <div className='form-group row'>
          <label className='col-sm-3 col-form-label text-lg-right'>{LangChooseFile} <b className='text-danger'>*</b></label>
          <div className='col-sm-4'>
            <input
              type='file'
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
              onChange={handleChangeFile}
            />
            <div className='help'>{LangMaxSize}: 500 KB</div>
            {errors.fields.file && <div className='invalid-feedback d-block'><strong>{errors.fields.file}</strong></div>}
          </div>
        </div>
        <hr />
        <div className='form-group row'>
          <div className='col-sm-9 offset-md-3'>
            {errors.message && <div className='alert alert-danger'>{errors.message}</div>}
            {importResult
              ? (
                <div>
                  <div className='alert alert-primary'>
                    {LangImportUpdateSuccessCount}: {importResult.success_count}
                    <br />{LangImportUpdateFailedCount}: {importResult.error_count}
                    {+importResult.error_count > 0 && (
                      <div>
                        <br />
                        {LangImportUpdateErrorReason}: <br />
                        <ol style={{ display: 'inline-block', marginLeft: '-25px' }}>
                          {importResult.errors.map((err, index) => (
                            <li key={index}>{LangRow} {err.row + 1} = {err.msg}</li>
                          ))}
                        </ol>
                        <br />
                        {LangImportErrorMsg1}
                        <br />
                        {LangImportErrorMsg2}
                      </div>
                    )}
                  </div>
                  <button onClick={handleClose} type='button' className='btn btn-light'>{LangImportDone}</button>
                </div>
              )
              : (
                <div>
                  <button disabled={control.showLoad} type='submit' className='btn btn-primary'>{control.showLoad ? SpinnerButton : null} {LangProcess}</button>
                  &nbsp;
                  <button disabled={control.showLoad} onClick={handleClose} type='button' className='btn btn-light'>{LangImportCancel}</button>
                </div>
              )}
          </div>
        </div>
      </form>

      {control.showModal === 'format-import' && (
        <ModalApp
          title={LangDownloadImportUpdateClientFormat}
          handleClose={() => setControl(curr => ({ ...curr, showModal: '' }))}
          body={
            <ClientImportUpdateFormatComponent
              redux={redux}
              onAfterAdd={() => setTimeout(() => setControl(curr => ({ ...curr, showModal: '' })), 1000)}
              handleClose={() => setControl(curr => ({ ...curr, showModal: '' }))}
            />
          }
        />
      )}
    </div>
  )
}

export default connect(mapStateToProps)(ClientImportUpdateComponent)
